import { createStore, select, withProps } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';

import { Form, FormSection } from '@state/form';
import { toString } from '@helpers/string';

import { Task, TaskVehicle } from './task.model';

export interface TaskProps {
  form?: Form;
  formValues: Record<string, unknown>;
  task?: Task;
  vehicle?: TaskVehicle;
}

function visibleSections(state: TaskProps) {
  let { formValues, task } = state;
  return task?.form?.sections.filter((section: FormSection) => {
    let { visibility_key, visibility_values } = section;

    if (visibility_key) {
      if (visibility_values.length) {
        // This is a special value for visibility
        let nullValueIndex = visibility_values.indexOf('**null**');
        if (nullValueIndex > -1) visibility_values[nullValueIndex] = '';

        let visibilityKey = toString(formValues[visibility_key]);
        return visibility_values.indexOf(visibilityKey) > -1;
      } else {
        return !formValues[visibility_key];
      }
    } else {
      return true;
    }
  });
}

export const taskStore$ = createStore(
  { name: 'task' },
  withProps<TaskProps>({
    form: undefined,
    formValues: {},
    task: undefined,
    vehicle: undefined
  })
);

@Injectable({ providedIn: 'root' })
export class TaskRepository {
  form$ = taskStore$.pipe(select((state) => state.form));
  task$ = taskStore$.pipe(select((state) => state.task));
  vehicle$ = taskStore$.pipe(select((state) => state.vehicle));
  visibleSections$ = taskStore$.pipe(
    map(visibleSections),
    filter((sections) => !!sections)
  );

  getValue(): TaskProps {
    return taskStore$.getValue();
  }

  reset(): void {
    taskStore$.reset();
  }

  setTask(task: Task): void {
    this.update({ task });
  }

  setTaskWithFormValues(task: Task, formValues: Record<string, unknown>): void {
    this.update({ formValues, task });
  }

  setFormAndVehicle(form: Form, vehicle: TaskVehicle): void {
    this.update({ form, vehicle });
  }

  private update(newState: Partial<TaskProps>): void {
    taskStore$.update((state) => ({ ...state, ...newState }));
  }
}
